// extracted by mini-css-extract-plugin
export var authNav = "Header-module--authNav--a573a";